"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateWithUSAIdx = exports.stateIdx = exports.states = exports.USGrid = exports.statesGrid = void 0;
const lodash_1 = __importDefault(require("lodash"));
exports.statesGrid = [[1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1], [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0], [0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0], [0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0], [1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0]];
exports.USGrid = [[1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0], [0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0], [0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0], [1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0]];
exports.states = [{
  abbr: 'AK',
  name: 'Alaska',
  fips: '02'
}, {
  abbr: 'ME',
  name: 'Maine',
  fips: '23'
}, {
  abbr: 'VT',
  name: 'Vermont',
  fips: '50'
}, {
  abbr: 'NH',
  name: 'New Hampshire',
  fips: '33'
}, {
  abbr: 'WA',
  name: 'Washington',
  fips: '53'
}, {
  abbr: 'MT',
  name: 'Montana',
  fips: '30'
}, {
  abbr: 'ND',
  name: 'North Dakota',
  fips: '38'
}, {
  abbr: 'MN',
  name: 'Minnesota',
  fips: '27'
}, {
  abbr: 'WI',
  name: 'Wisconsin',
  fips: '55'
}, {
  abbr: 'MI',
  name: 'Michigan',
  fips: '26'
}, {
  abbr: 'NY',
  name: 'New York',
  fips: '36'
}, {
  abbr: 'MA',
  name: 'Massachusetts',
  fips: '25'
}, {
  abbr: 'RI',
  name: 'Rhode Island',
  fips: '44'
}, {
  abbr: 'ID',
  name: 'Idaho',
  fips: '16'
}, {
  abbr: 'WY',
  name: 'Wyoming',
  fips: '56'
}, {
  abbr: 'SD',
  name: 'South Dakota',
  fips: '46'
}, {
  abbr: 'IA',
  name: 'Iowa',
  fips: '19'
}, {
  abbr: 'IL',
  name: 'Illinois',
  fips: '17'
}, {
  abbr: 'IN',
  name: 'Indiana',
  fips: '18'
}, {
  abbr: 'OH',
  name: 'Ohio',
  fips: '39'
}, {
  abbr: 'PA',
  name: 'Pennsylvania',
  fips: '42'
}, {
  abbr: 'NJ',
  name: 'New Jersey',
  fips: '34'
}, {
  abbr: 'CT',
  name: 'Connecticut',
  fips: '09'
}, {
  abbr: 'OR',
  name: 'Oregon',
  fips: '41'
}, {
  abbr: 'NV',
  name: 'Nevada',
  fips: '32'
}, {
  abbr: 'CO',
  name: 'Colorado',
  fips: '08'
}, {
  abbr: 'NE',
  name: 'Nebraska',
  fips: '31'
}, {
  abbr: 'MO',
  name: 'Missouri',
  fips: '29'
}, {
  abbr: 'KY',
  name: 'Kentucky',
  fips: '21'
}, {
  abbr: 'WV',
  name: 'West Virginia',
  fips: '54'
}, {
  abbr: 'VA',
  name: 'Virginia',
  fips: '51'
}, {
  abbr: 'MD',
  name: 'Maryland',
  fips: '24'
}, {
  abbr: 'DE',
  name: 'Delaware',
  fips: '10'
}, {
  abbr: 'CA',
  name: 'California',
  fips: '06'
}, {
  abbr: 'UT',
  name: 'Utah',
  fips: '49'
}, {
  abbr: 'NM',
  name: 'New Mexico',
  fips: '35'
}, {
  abbr: 'KS',
  name: 'Kansas',
  fips: '20'
}, {
  abbr: 'AR',
  name: 'Arkansas',
  fips: '05'
}, {
  abbr: 'TN',
  name: 'Tennessee',
  fips: '47'
}, {
  abbr: 'NC',
  name: 'North Carolina',
  fips: '37'
}, {
  abbr: 'SC',
  name: 'South Carolina',
  fips: '45'
}, {
  abbr: 'DC',
  name: 'District of Columbia',
  fips: '11'
}, {
  abbr: 'AZ',
  name: 'Arizona',
  fips: '04'
}, {
  abbr: 'OK',
  name: 'Oklahoma',
  fips: '40'
}, {
  abbr: 'LA',
  name: 'Louisiana',
  fips: '22'
}, {
  abbr: 'MS',
  name: 'Mississippi',
  fips: '28'
}, {
  abbr: 'AL',
  name: 'Alabama',
  fips: '01'
}, {
  abbr: 'GA',
  name: 'Georgia',
  fips: '13'
}, {
  abbr: 'HI',
  name: 'Hawaii',
  fips: '15'
}, {
  abbr: 'TX',
  name: 'Texas',
  fips: '48'
}, {
  abbr: 'FL',
  name: 'Florida',
  fips: '12'
}];
const statesWithUSA = [exports.states[0], {
  abbr: 'US',
  name: 'US',
  fips: 'US'
}, ...exports.states.slice(1)];
const stateIdx = grid => {
  const coords = (0, lodash_1.default)(grid).flatMap((d, i) => d.map((e, j) => e ? [i, j] : null)).filter(d => d).value();
  return coords.map((_ref, idx) => {
    let [i, j] = _ref;
    return {
      i,
      j,
      properties: exports.states[idx]
    };
  });
};
exports.stateIdx = stateIdx;
const stateWithUSAIdx = grid => {
  const coords = (0, lodash_1.default)(grid).flatMap((d, i) => d.map((e, j) => e ? [i, j] : null)).filter(d => d).value();
  return coords.map((_ref2, idx) => {
    let [i, j] = _ref2;
    return {
      i,
      j,
      properties: statesWithUSA[idx]
    };
  });
};
exports.stateWithUSAIdx = stateWithUSAIdx;